import React from "react";

function Label(props) {
    return React.createElement(
        props.as ? props.as : "label",
        {
            className: "block text-sm font-medium text-gray-700",
            htmlFor: props.htmlFor ? props.htmlFor : "",
        },
        props.label ? props.label : props.children
    );
}

export default Label;
